import { render } from "./Divider.vue?vue&type=template&id=775dc4f6&scoped=true"
const script = {}

import "./Divider.vue?vue&type=style&index=0&id=775dc4f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775dc4f6"]])

export default __exports__